<template>
		<div id="app">
				<router-view :key="$route.fullPath"></router-view>
		</div>
</template>

<script>
import Cookies from 'js-cookie'
import storage from './storage'
import axios from 'axios'
import {useStore} from 'vuex'
import {getCurrentInstance, onMounted} from 'vue'
import {useRoute} from "vue-router";
import router from "@/router";

export default {
		name: 'app',
		setup() {
				const store = useStore();
				const {proxy} = getCurrentInstance();
				const getUser = () => {
						axios.get('/wechat/index', {
								params: {
										path:'user/info'
								},
						}).then((res = {}) => {
								console.log('info',res);
								storage.setItem("user_info",res.data)
								store.commit('saveUserName', res.data.username);
								store.commit('saveUserInfo', res.data);
						})
				}

				const getSetting = () => {
						axios.get('/home/getSetting', {
								params: {},
						}).then((res = {}) => {
								console.log('info',res);
								//storage.setItem("Setting",res.data);
								store.commit('saveSettimg', res.data);
								// 全局设置页面标题
								router.beforeEach((to) => {
										if (to.meta.title) {
												document.title = to.meta.title+'-'+res.data.webname
										} else {
												document.title = res.data.webname // 设置一个默认标题
										}
								})
						})
				}

				const getNavList = () => {
						proxy.$axios.get("/home/getColumnList", {
								params: {},
						}).then((res) => {
										console.log("getColumnList",res);
										proxy.$store.commit("saveCatList", res.data);
										storage.setItem('catList', res.data);
								});
				};

				const _isMobile= () =>{
						let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
						return flag
				}
				onMounted(() => {
						const router=useRoute();
						setTimeout(() => {
								if(_isMobile() && router.fullPath.indexOf('mobile')==-1){
										proxy.$router.replace('/mobile'+router.fullPath);
								}
								if(!_isMobile() && router.fullPath.indexOf('mobile')!=-1){
										let newPath=router.fullPath.replace('/mobile','');
										proxy.$router.replace(newPath);
								}
						}, 500);
						if (Cookies.get('token')) {
								getUser();
						}
						getSetting();
						getNavList();
				})
				return {
						getUser,
				}
		}
}
</script>

<style lang="scss">
@import './assets/scss/config.scss';
@import './assets/scss/button.scss';

textarea::placeholder, input::placeholder {
		color: #aaaaaa;
}

.page-header {
		min-width: 1200px;
		width: 100%;
		position: relative;
}

.page-header img {
		width: 100%;
}

.page-header .s {
		position: absolute;
		left: 0;
		width: 100%;
		top: 98px;
		z-index: 2;
		text-align: center;
		color: #ffffff;
		font-size: 52px;
		font-weight: bold;
}

.m-page-header {
		width: 100%;
		position: relative;
}

.m-page-header img {
		/*width: 100%;*/
		height: 2rem;
}

.m-page-header .s {
		position: absolute;
		left: 0;
		width: 100%;
		top: 0.7rem;
		z-index: 2;
		text-align: center;
		color: #ffffff;
		font-size: 0.4rem;
		font-weight: bold;
}

.selectBox {
		border-bottom: 1px solid #f1f1f1;
		height: 70px;
		margin-bottom: 50px;

		ul {
				width: 1200px;
				justify-content: space-evenly;

				li {
						text-align: center;
						font-size: 17px;
						height: 70px;
						line-height: 70px;

						a {
								color: #333333;
						}

						&.active, &:hover {
								cursor: pointer;
								color: #ffce0e;
								border-bottom: 2px solid #ffce0e;

								a {
										color: #ffce0e;
								}
						}
				}
		}
}
.m-selectBox{
		border-bottom: 1px solid #ffffff;
		height: 0.6rem;
		margin-bottom: 0.2rem;
		margin-top: 0.2rem;
		ul {
				width: 100%;
				justify-content: space-evenly;

				li {
						text-align: center;
						font-size: 0.23rem;
						height: 0.6rem;
						line-height:0.6rem;

						a {
								color: #333333;
						}

						&.active, &:hover {
								cursor: pointer;
								color: #ffce0e;
								border-bottom: 2px solid #ffce0e;

								a {
										color: #ffce0e;
								}
						}
				}
		}
}


.search-box {
		height: 70px;
		width: 1000px;

		input {
				height: 60px;
				line-height: 60px;
				width: 100%;
				border: 1px solid #f1f1f1;
				border-radius: 10px;
				padding: 15px;
				color: #333333;
				font-size: 16px;
		}

		.btn {
				height: 60px;
				line-height: 60px;
				background: #ffce0e;
				width: 120px;
				border-radius: 10px;
				margin-left: 20px;
				font-size: 20px;
		}

		.iconfont {
				font-size: 23px;
				color: #ffffff;
				display: inline-block;
				font-weight: bold;
		}
}

.k_cont_box {
		display: table;
		min-width: 1200px;
		font-family: 'Microsoft Yahei,寰蒋闆呴粦';
		margin: 0 auto;
		padding: 20px 0;
}

.k_contact_top {
		float: left;
		line-height: 50px;
		width: 280px;
		background: #ffffff;
		padding-bottom: 50px;
}

.k_contact_top .top-title {
		background: #ffce0e;
		color: #000000;
		font-size: 22px;
		padding-left: 20px;
		font-family: "siyuan";
}

.k_contact_title {
		padding-left: 20px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		display: table;
}

.k_contact_title ul {
		text-align: center;
		display: table;
}

.k_contact_title ul a {
		display: block;
		float: left;
		width: 100%;
}

.k_contact_title ul li {
		float: left;
		text-align: center;
		color: #666666;
}

.k_contact_title ul li:hover, .k_contact_title ul a:hover, .k_contact_title ul li.cur {
		color: #ffce0e
}

.k_cont_cont {
		width: 900px;
		margin: 0 auto;
		font-size: 16px;
		float: right;
		background: #ffffff;
		min-height: 500px;
		padding: 20px 10px
}

.k_cont_cont .content {
		margin: 10px 8px;
		line-height: 28px;
}

/*分页*/
.ant-pagination {
		display: flex;
		flex-direction: row;
		justify-content: center;
}

.ant-pagination-item:hover {
		border-color: #c49658;
}

.ant-pagination-item-active {
		border-color: #c49658;
}

.ant-pagination-item-active:hover a, .ant-pagination-item-active a, .ant-pagination-item:hover a {
		color: #c49658;
}

@media screen and (min-width: 960px) {
		.page-header {
				min-width: 100%;
				width: 100%;
				position: relative;
		}

}

@media screen and (min-width: 320px) {html{font-size:50px!important;}}
@media screen and (min-width: 360px) {html{font-size:56.25px!important;;}}
@media screen and (min-width: 375px) {html{font-size:58.59375px!important;;}}
@media screen and (min-width: 400px) {html{font-size:62.5px!important;;}}
@media screen and (min-width: 414px) {html{font-size:64.6875px!important;;}}
@media screen and (min-width: 440px) {html{font-size:68.75px!important;;}}
@media screen and (min-width: 480px) {html{font-size:75px!important;;}}
@media screen and (min-width: 520px) {html{font-size:81.25px!important;;}}
@media screen and (min-width: 560px) {html{font-size:87.5px!important;;}}
@media screen and (min-width: 600px) {html{font-size:93.75px!important;;}}
@media screen and (min-width: 640px) {html{font-size:100px!important;;}}
@media screen and (min-width: 680px) {html{font-size:100px!important;;}}
@media screen and (min-width: 720px) {html{font-size:100px!important;;}}
@media screen and (min-width: 760px) {html{font-size:118.75px!important;;}}
@media screen and (min-width: 800px) {html{font-size:100px!important;;}}
@media screen and (min-width: 960px) {html{font-size:100px!important;;}}
</style>
